const main = () => {
    if(document.querySelector('.c-others-foot-modal') === null) return;
    document.querySelector('.c-others-foot-modal .c-buttons-close').addEventListener('click', (e) => {
        e.preventDefault();
        delete document.querySelector('.c-others-foot-modal').dataset.isOpen;
    });

    document.querySelectorAll('[data-open-foot]').forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelector('.c-others-foot-modal').dataset.isOpen = '';
        });
    });
}

export default main
